import { render } from "./VotingSystemEdit.vue?vue&type=template&id=783db38e&ts=true"
import script from "./VotingSystemEdit.vue?vue&type=script&lang=ts"
export * from "./VotingSystemEdit.vue?vue&type=script&lang=ts"

import "./VotingSystemEdit.vue?vue&type=style&index=0&id=783db38e&lang=scss"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__